import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoubleCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.02917 8.7589L4.54504 11.2747L10.5699 5.25",
		stroke: "#3C59F6",
		strokeWidth: 2.0277,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.73816 9.55578L10.254 12.0716L16.2789 6.04688",
		stroke: "#3C59F6",
		strokeWidth: 2.0277,
		strokeLinecap: "round"
	})]
});
export default SvgDoubleCheckmark;
